module.exports = __webpack_public_path__ + "media/images/ferrari-2aa6b5ef14809ba4114ba50036b794bf.svg";